import React from 'react';
import { Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';

export default function BlockedAlert({ show, message }) {
  if (!show) return null;
  return (
    <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1060 }}>
      <Alert variant="warning" className="shadow">
        {message}
      </Alert>
    </div>
  );
}

BlockedAlert.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
};
